import React, { useState } from 'react';
import { auth } from '../serices/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Loader2, AlertCircle } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin'); // Redirect to dashboard on success
    } catch (err) {
      setError('Invalid Admin Credentials. Access Denied.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#D4AF37]/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-black italic uppercase tracking-tighter text-white mb-2">
            MZINYI <span className="text-[#D4AF37]">ADMIN</span>
          </h1>
          <p className="text-[10px] font-bold text-white/30 uppercase tracking-[0.4em]">Authorized Access Only</p>
        </div>

        <form onSubmit={handleLogin} className="bg-zinc-900/50 border border-white/10 p-10 rounded-3xl backdrop-blur-xl">
          {error && (
            <div className="bg-red-500/10 border border-red-500/50 p-4 rounded-xl mb-8 flex items-center gap-3 text-red-500 text-xs font-bold uppercase tracking-widest">
              <AlertCircle size={16} /> {error}
            </div>
          )}

          <div className="space-y-6">
            <div>
              <label className="text-[10px] font-black text-[#D4AF37] uppercase tracking-widest mb-3 block pl-1">Admin Identity</label>
              <div className="relative flex items-center">
                <User className="absolute left-4 text-white/20" size={18} />
                <input 
                  type="email" 
                  required 
                  placeholder="Email Address"
                  className="w-full bg-black border border-white/10 rounded-xl py-4 pl-12 pr-4 text-white outline-none focus:border-[#D4AF37] transition-all"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div>
              <label className="text-[10px] font-black text-[#D4AF37] uppercase tracking-widest mb-3 block pl-1">Passkey</label>
              <div className="relative flex items-center">
                <Lock className="absolute left-4 text-white/20" size={18} />
                <input 
                  type="password" 
                  required 
                  placeholder="••••••••"
                  className="w-full bg-black border border-white/10 rounded-xl py-4 pl-12 pr-4 text-white outline-none focus:border-[#D4AF37] transition-all font-mono"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          <button 
            disabled={loading}
            className="w-full bg-[#D4AF37] text-black py-5 rounded-xl font-black uppercase tracking-[0.3em] mt-10 hover:bg-white transition-all duration-500 flex justify-center items-center gap-3 disabled:opacity-50 shadow-xl shadow-[#D4AF37]/10"
          >
            {loading ? <Loader2 className="animate-spin" /> : "Verify Identity"}
          </button>
        </form>

        <p className="text-center mt-12 text-[9px] text-white/20 uppercase tracking-[0.3em] font-bold">
            &copy; 2026 MZINYI SECURITY PROTOCOL
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;